import {
  AddAPhoto,
  ArrowDropDownCircle,
  AttachMoney,
  CalendarMonth,
  Keyboard,
  Numbers,
  Upload,
} from "@mui/icons-material";

export default function AssetFieldIcon({ type, fontSize = "medium" }) {
  if (type === 1) return <Keyboard fontSize={fontSize} />;
  if (type === 2) return <Numbers fontSize={fontSize} />;
  if (type === 3) return <AttachMoney fontSize={fontSize} />;
  if (type === 4) return <AddAPhoto fontSize={fontSize} />;
  if (type === 5) return <Upload fontSize={fontSize} />;
  if (type === 6) return <CalendarMonth fontSize={fontSize} />;
  if (type === 7) return <ArrowDropDownCircle fontSize={fontSize} />;
  return "";
}
